import { getShortIdFromUuid } from '../utils/getShortIdFromUuid';
import { Result1, Dependency1 } from './Result1';

/**
 * Factory function to create a Result1 object with all required fields, including versioning and migration compatibility.
 * Ensures both deadline and forIntervalEnding are set and in sync, and sets version: 2 by default.
 * Always uses deadline as the canonical value.
 */
export function createResult1(props: Partial<Result1>): Result1 {
  const now = new Date().toISOString();
  const uuid = props.uuid ?? crypto.randomUUID();
  const deadline = props.deadline ?? props.forIntervalEnding;
  const shortId = props.shortId ?? getShortIdFromUuid(uuid);
  const result = {
    uuid,
    shortId,
    text: props.text ?? '',
    isKeyResult: props.isKeyResult ?? false,
    delivered: props.delivered ?? false,
    deadline,
    forIntervalEnding: deadline,
    createdDate: props.createdDate ?? now,
    createdBy: props.createdBy ?? '',
    lastUpdatedDate: props.lastUpdatedDate ?? now,
    lastUpdatedBy: props.lastUpdatedBy ?? '',
    dependencies: props.dependencies ?? Array<Dependency1>(),
    version: props.version ?? 2,
    ownerName: props.ownerName ?? '',
    ownerId: props.ownerId ?? '',
  };

  // Runtime validation to ensure result is a proper Result1
  if (!result.uuid || !result.shortId || !result.text || !result.deadline || !result.createdDate) {
    throw new Error('Invalid Result1: missing required fields');
  }

  return result as Result1;
}
